/**
 * Реестр решений WEBDAD (раздел /os).
 *
 * Здесь живут только данные для каталога и навигации (меню, футер, sitemap).
 * Контент самих страниц остаётся в `src/app/(site)/os/<slug>/page.tsx`,
 * чтобы каждое решение можно было верстать и оптимизировать под SEO отдельно.
 */

export type Product = {
  slug: string
  /** Название продукта, как оно звучит в каталоге и меню. */
  name: string
  /** Короткое пояснение — одна строка под названием. */
  tagline: string
  /** Развёрнутое описание для каталога, JSON-LD и метаданных. */
  description: string
  href: string
  category: string
  /** Имя иконки из набора solar (см. `@/shared/ui/icon`). */
  icon: string
  /** Tailwind-градиент для плитки в каталоге. */
  accent: string
  highlights: string[]
  /** Бейдж цены входа для карточки каталога, напр. «Вход от $490». */
  entryBadge?: string
  /** Бейдж подписки для карточки каталога, напр. «Подписка от $99/мес». */
  subscriptionBadge?: string
}

export const products: Product[] = [
  {
    slug: "pulse",
    name: "Пульс",
    tagline: "Видно всё, что происходит",
    description:
      "Слой прозрачности и контроля: собирает события из ваших систем и каналов на один экран, сравнивает их с вашими нормами и сам поднимает тревогу, когда что-то пошло не так.",
    href: "/os/pulse",
    category: "Analytics",
    icon: "pulse-bold-duotone",
    accent: "from-emerald-300 to-teal-700",
    highlights: [
      "События из CRM, 1С, почты и чатов",
      "Один экран вместо ручных выгрузок",
      "Сигнал об отклонении — ответственному",
      "Утренняя сводка в Telegram",
    ],
  },
  {
    slug: "ai-business-assistant",
    name: "Атлас",
    tagline: "ИИ бизнес-ассистент",
    description:
      "AI-ассистент в привычном чате: отвечает на вопросы сотрудников и клиентов, готовит документы и отчёты, заводит задачи и подтягивает данные из ваших систем.",
    href: "/os/ai-business-assistant",
    category: "AI",
    icon: "chat-round-dots-bold-duotone",
    accent: "from-violet-300 to-indigo-700",
    highlights: [
      "Чат в Telegram и на сайте",
      "Знает ваши регламенты и данные",
      "Создаёт задачи и документы",
      "Интеграции с CRM и базой знаний",
    ],
    entryBadge: "Пилот $990",
    subscriptionBadge: "База от $149/мес",
  },
  {
    slug: "platform-as-a-service",
    name: "Хостинг",
    tagline: "Размещайте ваши приложения",
    description:
      "Управляемая платформа для запуска приложений и баз данных: деплой, домены, SSL, мониторинг и бэкапы на нашей или вашей инфраструктуре — без собственной команды DevOps.",
    href: "/os/platform-as-a-service",
    category: "Infrastructure",
    icon: "server-square-cloud-bold-duotone",
    accent: "from-cyan-300 to-blue-700",
    highlights: [
      "Деплой из Git в один клик",
      "Домены, SSL и окружения",
      "Мониторинг и бэкапы",
      "Без vendor lock-in",
    ],
    entryBadge: "Установка от $290",
    subscriptionBadge: "Платформа от $49/мес",
  },
]

export const getProduct = (slug: string): Product | undefined =>
  products.find((product) => product.slug === slug)
